import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { Mensagens } from '../shared/utils/mensagens';

import { environment } from 'environments/environment';

export abstract class BaseService {

    private server = environment.urlSegurancaApi;
    private serverComunicacao = environment.urlComunicacaoApi;

    protected api = '/api/v2';

    protected urlApi = this.server + this.api;
    protected urlApiComunicacao = this.serverComunicacao;

    protected handleError(error: Response | any) {
        const retorno = new Array();

        if (error.status === 401 || error.status === 403) {
            retorno.push(Mensagens.NaoPossuiPermissaoOuSessaoExpirou);
            return Observable.throw(retorno);
        }

        const erro = error.json();

        if (erro.errors) {
            const body = JSON.parse(error._body)

            body.errors.forEach(element => {
                retorno.push(element);
            });

            return Observable.throw(retorno);
        }

        const mensagemErro = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` :
                Mensagens.OcorreuErroInesperado;

        console.error(error, mensagemErro);
        retorno.push(mensagemErro);

        return Observable.throw(retorno);
    }

    protected extractData(response: Response) {
        const body = response.json();
        return body || {};
    }

    protected extractArrayData(response: Response) {
        const body = response.json();
        return body || [];
    }

    protected extractPostData(response: Response) {
        const body = response.json();
        return body.data || {};
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/base.service.ts